import { NgModule, ModuleWithProviders, Provider } from '@angular/core';

import { AppComponent } from './app.component';
import { Common2Module } from 'projects/common/src/app/app.module';
import { AuthenticationService } from './services';
import { CanActiveAuthorizationModuleService } from './services/guard';
import { AuthenticationInterceptorService } from './services/interceptors';
import { TokenService } from './services/parameters';
import { SignalRService } from './services/signal-r.service';

const providers: Provider[] = [
  TokenService,
  AuthenticationService,
  CanActiveAuthorizationModuleService,
  AuthenticationInterceptorService,
  SignalRService
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    Common2Module.forRoot(),
  ],
  providers,
  bootstrap: [AppComponent]
})
export class AppModule { }

@NgModule({})
export class AuthenticationModule{
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule,
      providers,
    };
  }
}
